<template>
  <div>
    <v-btn color="primary" flat @click="reset">Reset filtering</v-btn>
    <v-layout row wrap justify-space-around>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Search by first name"
          v-model="search.firstName"
        />
      </v-flex>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Search by last name"
          v-model="search.lastName"
        />
      </v-flex>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Search by company"
          v-model="search.company"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Search by job title"
          v-model="search.jobTitle"
        />
      </v-flex>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Search by sender email"
          v-model="search.senderEmail"
        />
      </v-flex>
      <v-flex xs3>
        <v-text-field
          append-icon="search"
          label="Search by receiver email"
          v-model="search.receiverEmail"
        />
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="getAttendeesMessages"
      class="elevation-1 wrap"
      :pagination.sync="pagination"
      :total-items="getMessagesTotalItems"
      :loading="loading"
      item-key="id"
      :disable-initial-sort="true"
    >
      <template slot="items" slot-scope="props">
        <td class="py-4">{{ props.item.receiverEmail }}</td>
        <td class="py-4">{{ props.item.senderEmail }}</td>
        <td class="py-4">{{ props.item.senderFirstName }}</td>
        <td class="py-4">{{ props.item.senderLastName }}</td>
        <td class="py-4">{{ props.item.senderCompany }}</td>
        <td class="py-4">{{ props.item.senderJobTitle }}</td>
        <td class="py-4">{{ `${props.item.message.slice(0, 10)}...` }}</td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="info"
              fab flat
              slot="activator"
              @click.stop="openDetails(props.item)"
            >
              <v-icon>widgets</v-icon>
            </v-btn>
            <span>Open message details</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="pageText" slot-scope="{}">
        Page {{ pagination.page }} of {{ getMessagesTotalPages }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="isDetailsOpen"
      max-width="900"
      persistent
    >
      <attendees-messages-details
        v-if="isDetailsOpen"
        :details="details"
        @closeModal="closeDetails"
      />
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { timeSettings } from '@/modules/settings/'
  import debounce from 'lodash.debounce'
  import { equals, clone } from 'ramda'
  import AttendeesMessagesDetails from './attendeesMessagesDetails'

  export default {
    components: {AttendeesMessagesDetails},
    name: 'AttendeesMessages',
    data () {
      return {
        isConfirmationUnblock: false,
        itemToUnblock: '',
        isConfirmationDeleteForever: false,
        itemToDeleteForever: '',
        isChooseEmailTemplateBlock: false,
        selectedAttendeeId: '',
        emailTemplateKey: '',
        search: {
          firstName: '',
          lastName: '',
          company: '',
          jobTitle: '',
          senderEmail: '',
          receiverEmail: ''
        },
        editModal: false,
        editedAttendee: null,
        objOfCategory: {},
        objOfTypeAttendee: {},
        objOfStatus: {},
        headers: [
          { text: 'Receiver Email', value: 'receiveremail', search: true, sortable: true, width: 100 },
          { text: 'Sender Email', value: 'senderemail', search: true, sortable: true, width: 100 },
          { text: 'First Name', value: 'firstName', search: true, sortable: true, width: 100 },
          { text: 'Last Name', value: 'lastName', search: true, sortable: true, width: 100 },
          { text: 'Company', value: 'company', search: true, sortable: true, width: 100 },
          { text: 'Job Title', value: 'jobtitle', search: true, sortable: true, width: 100 },
          { text: 'Message', value: 'message', search: true, sortable: true, width: 100 },
          { text: 'Open Details', sortable: false, align: 'center', width: 30 }
        ],
        pagination: {
          rowsPerPage: 5
        },
        details: null,
        isDetailsOpen: false,
        loading: true
      }
    },
    computed: {
      ...mapGetters([
        'getAttendeesMessages',
        'getMessagesTotalItems',
        'getMessagesTotalPages'
      ])
    },
    watch: {
      pagination: {
        handler () {
          this.fetchMessages()
        },
        deep: true
      },
      search: {
        handler () {
          this.fetchMessages()
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'fetchAttendeesMessages',
      ]),
      reset () {
        Object.keys(this.search).forEach(val=> this.search[val] = '' )
        this.pagination.sortBy = null
        this.pagination.descending = false
        this.fetchMessages()
      },
      fetchMessages: debounce(async function () {
        this.loading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let itemsOnPage = equals(rowsPerPage, -1) ? this.totalAttendeeItems : rowsPerPage
        const sort = descending ? 'Desc' : 'Asc'
        const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const getParams = {
          page: pageCheck,
          itemsOnPage,
          filter: {
            firstName: this.search.firstName,
            lastName: this.search.lastName,
            company: this.search.company,
            jobTitle: this.search.jobTitle,
            senderEmail: this.search.senderEmail,
            receiverEmail: this.search.receiverEmail
          },
          sort,
          name
        }
        await this.fetchAttendeesMessages(getParams)
        this.loading = false
      }, timeSettings.delayTime),
      openDetails (details) {
        this.details = Object.assign(details)
        this.isDetailsOpen = true
      },
      closeDetails () {
        this.isDetailsOpen = false
      }
    },
    async mounted () {
      await this.fetchMessages()
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/AttendeesMessages/index.vue